export const ORGANIZATION_FILTER_GROUPS = [
  {
    id: 'location',
    label: 'Location',
    filters: [
      {
        id: 'city',
        label: 'City',
        type: 'search',
        options: []
      },
      {
        id: 'state',
        label: 'State',
        type: 'search',
        options: []
      },
      {
        id: 'country',
        label: 'Country',
        type: 'checkbox',
        options: []
      }
    ]
  },
  {
    id: 'contact_info',
    label: 'Contact Info',
    filters: [
      {
        id: 'has_email',
        label: 'Has Email',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_phone',
        label: 'Has Phone',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_website',
        label: 'Has Website',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      }
    ]
  },
  {
    id: 'dates',
    label: 'Dates',
    filters: [
      {
        id: 'created_at',
        label: 'Created Date',
        type: 'date_range',
        options: []
      }
    ]
  }
];

export const getFilterGroupById = (id) => {
  return ORGANIZATION_FILTER_GROUPS.find(group => group.id === id);
};

export const getFilterById = (filterId) => {
  for (const group of ORGANIZATION_FILTER_GROUPS) {
    const filter = group.filters.find(f => f.id === filterId);
    if (filter) {
      return filter;
    }
  }
  return null;
};

export const getActiveFilterCount = (activeFilters) => {
  return Object.values(activeFilters).reduce((count, values) => {
    if (Array.isArray(values) && values.length > 0) {
      return count + 1;
    }
    if (typeof values === 'object' && values !== null && !Array.isArray(values)) {
      const hasValue = Object.values(values).some(v => v !== '' && v !== null && v !== undefined);
      if (hasValue) {
        return count + 1;
      }
    }
    return count;
  }, 0);
};
